import { WebEnv } from '@easy-expense/env-mobile';
import { initializeApp, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

let app = getApp();
if (!app) {
  app = initializeApp(WebEnv.firebase);
}

export const auth = getAuth(app);
